import { render, staticRenderFns } from "./BaseFilterTagItemSearches.vue?vue&type=template&id=3a7493f4&scoped=true"
import script from "./BaseFilterTagItemSearches.vue?vue&type=script&lang=js"
export * from "./BaseFilterTagItemSearches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7493f4",
  null
  
)

export default component.exports